<template>
  <div>
    <video v-if="true" id="localVideoB" autoplay></video>
    {{ localStream ? "STREAMING VIDEO" : "" }}
    <video id="remoteVideoB" autoplay />
    <b-button
      id="joinBtnB"
      variant="primary"
      @click="handleStartLiveMonitor"
      :disabled="!localStream"
    >
      Enable Monitor
    </b-button>
    <button id="hangupBtn" @click="hangUp">Hang Up</button>
    <div id="currentRoom">{{ currentRoom }}</div>
  </div>
</template>

<script>
import firebase from "firebase";
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
export default {
  name: "Display_PaneRTC",
  mixins: [ResourceBlockDisplay],
  mounted() {
    this.init();
    this.getConnectedDevices("videoinput", cameras =>
      console.log("Cameras found", cameras)
    );
    this.getConnectedDevices("audioinput", audios =>
      console.log("Cameras found", audios)
    );
  },
  props: {
    rootPathCollection: {
      type: String,
      default: "rtcs"
    },
    monitorName: {
      type: String,
      default: "Den"
    },
    idName: {
      type: String,
      default: "SessionId"
    }
  },
  computed: {
    localIcePath() {
      return this.roomId && this.rootPathCollection && this.idName
        ? `${this.rootPathCollection}/${this.roomId}/${this.idName}/ice/local`
        : null;
    },
    remoteIcePath() {
      return this.roomId && this.rootPathCollection && this.idName
        ? `${this.rootPathCollection}/${this.roomId}/${this.idName}/ice/remote`
        : null;
    },
    monitorSessionObj() {
      let filteredSession =
        this.userData &&
        this.userData.sessions &&
        Array.isArray(this.userData.sessions) &&
        this.sessionId
          ? this.userData.sessions.filter(aSessionName => {
              return aSessionName.name == this.monitorName;
            })
          : null;
      return filteredSession &&
        Array.isArray(filteredSession) &&
        filteredSession.length > 0
        ? filteredSession[0]
        : null;
    }
  },
  methods: {
    async init() {
      //this.roomDialog = new mdc.dialog.MDCDialog(document.querySelector('#room-dialog'));
      // Add event listeners
      this.openUserMedia();
    },
    async openUserMedia() {
      debugger;
      // Open user media logic
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true
      });
      document.querySelector("#localVideoB").srcObject = stream;
      this.localStream = stream;
      this.remoteStream = new MediaStream();
      document.querySelector("#remoteVideoB").srcObject = this.remoteStream;
      console.log(
        "Local Stream:",
        document.querySelector("#localVideoB").srcObject
      );

      //document.querySelector('#cameraBtn').disabled = true;
      //document.querySelector('#createBtn').disabled = false;
      //document.querySelector('#hangupBtn').disabled = false;
    },
    getConnectedDevices(type, callback) {
      navigator.mediaDevices.enumerateDevices().then(devices => {
        const filtered = devices.filter(device => device.kind === type);
        callback(filtered);
      });
    },
    handleStartLiveMonitor() {
      debugger;
      if (this.monitorSessionObj && this.monitorSessionObj.camRTCId) {
        this.roomId = this.monitorSessionObj.camRTCId;
        this.joinWithRoomIdAndSessionId();
      }
    },
    async joinWithRoomIdAndSessionIdOld() {
      debugger;
      if (this.roomId) {
        const db = firebase.firestore();
        const roomRef = db.collection(this.rootPathCollection).doc(this.roomId);
        const roomSnapshot = await roomRef.get();
        console.log("Got room:", roomSnapshot.exists);

        if (roomSnapshot.exists) {
          console.log(
            "Create PeerConnection with configuration: ",
            this.configuration
          );
          this.peerConnection = new RTCPeerConnection(this.configuration);
          this.registerPeerConnectionListeners();
          this.localStream.getTracks().forEach(track => {
            this.peerConnection.addTrack(track, this.localStream);
          });

          // Code for collecting ICE candidates below
          this.collectIceCandidates(
            roomRef,
            this.peerConnection,
            this.localIcePath,
            this.remoteIcePath
          );
          // Code for collecting ICE candidates above

          this.peerConnection.addEventListener("track", event => {
            console.log("Got remote track:", event.streams[0]);
            event.streams[0].getTracks().forEach(track => {
              console.log("Add a track to the remoteStream:", track);
              this.remoteStream.addTrack(track);
            });
          });

          // Code for creating SDP answer below
          const offer = roomSnapshot.data().offer;
          await this.peerConnection.setRemoteDescription(offer);
          const answer = await this.peerConnection.createAnswer();
          await this.peerConnection.setLocalDescription(answer);

          const roomWithAnswer = {
            answer: {
              type: answer.type,
              sdp: answer.sdp
            }
          };
          await roomRef.update(roomWithAnswer);
          // Code for creating SDP answer above

          // Listening for remote ICE candidates below

          // Listening for remote ICE candidates above
        }
      }
    },
    async joinWithRoomIdAndSessionId() {
      debugger;
      const db = firebase.firestore();
      const roomRef = db.collection(this.rootPathCollection).doc(this.roomId);
      const roomSnapshot = await roomRef.get();
      console.log("Got room:", roomSnapshot.exists);

      if (roomSnapshot.exists) {
        this.peerConnection = new RTCPeerConnection(this.configuration);
        this.registerPeerConnectionListeners();
        this.localStream.getTracks().forEach(track => {
          this.peerConnection.addTrack(track, this.localStream);
        });

        const calleeCandidatesCollection = roomRef.collection(
          "calleeCandidates"
        );
        this.peerConnection.addEventListener("icecandidate", event => {
          if (!event.candidate) {
            console.log("Got final candidate!");
            return;
          }
          console.log("Got candidate: ", event.candidate);
          calleeCandidatesCollection.add(event.candidate.toJSON());
        });

        this.peerConnection.addEventListener("track", event => {
          console.log("Got remote track:", event.streams[0]);
          event.streams[0].getTracks().forEach(track => {
            console.log("Add a track to the remoteStream:", track);
            this.remoteStream.addTrack(track);
          });
        });

        const offer = roomSnapshot.data().offer;
        console.log("Got offer:", offer);
        await this.peerConnection.setRemoteDescription(
          new RTCSessionDescription(offer)
        );
        const answer = await this.peerConnection.createAnswer();
        console.log("Created answer:", answer);
        await this.peerConnection.setLocalDescription(answer);

        const roomWithAnswer = {
          answer: {
            type: answer.type,
            sdp: answer.sdp
          }
        };
        await roomRef.update(roomWithAnswer);

        roomRef.collection("callerCandidates").onSnapshot(snapshot => {
          snapshot.docChanges().forEach(async change => {
            if (change.type === "added") {
              let data = change.doc.data();
              console.log(
                `Got new remote ICE candidate: ${JSON.stringify(data)}`
              );
              await this.peerConnection.addIceCandidate(
                new RTCIceCandidate(data)
              );
            }
          });
        });
      }
    },
    async hangUp() {
      // Hang up logic
    },
    async collectIceCandidates(
      roomRef,
      peerConnection,
      localIcePath,
      remoteIcePath
    ) {
      debugger;
      const candidatesCollection = roomRef.collection(localIcePath);

      peerConnection.addEventListener("icecandidate", event => {
        debugger;
        if (event.candidate) {
          const json = event.candidate.toJSON();
          candidatesCollection.add(json);
        }
      });

      roomRef.collection(remoteIcePath).onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          debugger;
          if (change.type === "added") {
            const candidate = new RTCIceCandidate(change.doc.data());
            peerConnection.addIceCandidate(candidate);
          }
        });
      });
    },
    registerPeerConnectionListeners() {
      this.peerConnection.addEventListener("icegatheringstatechange", () => {
        console.log(
          `ICE gathering state changed: ${this.peerConnection.iceGatheringState}`
        );
      });

      this.peerConnection.addEventListener("connectionstatechange", () => {
        console.log(
          `Connection state change: ${this.peerConnection.connectionState}`
        );
      });

      this.peerConnection.addEventListener("signalingstatechange", () => {
        console.log(
          `Signaling state change: ${this.peerConnection.signalingState}`
        );
      });

      this.peerConnection.addEventListener("iceconnectionstatechange", () => {
        console.log(
          `ICE connection state change: ${this.peerConnection.iceConnectionState}`
        );
      });
    },
    registerPeerConnectionListenersOld() {
      this.peerConnection.addEventListener("icegatheringstatechange", () => {
        console.log(
          `ICE gathering state changed: ${this.peerConnection.iceGatheringState}`
        );
      });

      this.peerConnection.addEventListener("connectionstatechange", () => {
        console.log(
          `Connection state change: ${this.peerConnection.connectionState}`
        );
      });

      this.peerConnection.addEventListener("signalingstatechange", () => {
        console.log(
          `Signaling state change: ${this.peerConnection.signalingState}`
        );
      });

      this.peerConnection.addEventListener("iceconnectionstatechange ", () => {
        console.log(
          `ICE connection state change: ${this.peerConnection.iceConnectionState}`
        );
      });
    }
  },
  data() {
    return {
      roomId: null,
      settingsUser: this.settings.user,
      peerConnection: null,
      localStream: null,
      remoteStream: new MediaStream(),
      roomDialog: null,
      currentRoom: "",
      configuration: {
        iceServers: [
          {
            urls: [
              "stun:stun1.l.google.com:19302",
              "stun:stun2.l.google.com:19302"
            ]
          }
        ],
        iceCandidatePoolSize: 10
      }
    };
  }
};
</script>

<style lang="scss" scoped>
body {
  margin: 0;
}
video {
  width: 100%;
  max-height: 100%;
  box-sizing: border-box;
  border-radius: 15px;
}
</style>
